import { render, staticRenderFns } from "./destroy-to-stock.vue?vue&type=template&id=698870ca&scoped=true"
import script from "./destroy-to-stock.vue?vue&type=script&lang=js"
export * from "./destroy-to-stock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698870ca",
  null
  
)

export default component.exports